import { render, staticRenderFns } from "./ServerMaintenance.vue?vue&type=template&id=b62ec772"
import script from "./ServerMaintenance.vue?vue&type=script&lang=js"
export * from "./ServerMaintenance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports